module.exports = __webpack_public_path__ + "static/media/members-icon.f8598c23.svg";